import { EventNotification } from "../../domain/EventNotification";

export const defaultAffectedQualification = { id: null };

export const defaultValues: Partial<EventNotification> = {
  regulatorsAffectedOfqual: false,
  regulatorsAffectedCcea: false,
  regulatorsAffectedQw: false,
  regulatorsAffectedIFATE: false,

  orgId: null,
  title: null,
  dateOfEvent: null,
  dateAware: null,
  reasonForDelayInNotifying: null,

  eventNotificationExamSeries: [],

  howBecameAware: null,
  natureAndCause: null,
  adverseEffect: null,
  potentialOrActualAdverseEffect: null,

  eventNotificationWhoIsAware: [],
  whoIsAwareDetails: null,

  dateOfNextUpdate: null,
  additionalInformation: null,
  
  informationOnQualsUnitsAffected: null,

  eventNotificationCentres: [],

  englandCentresAffected: false,
  englandCentresEntered: null,
  englandCentresDirectlyAffected: null,
  englandCentresIndirectlyAffected: null,
  englandLearnersEntered: null,
  englandLearnersDirectlyAffected: null,
  englandLearnersIndirectlyAffected: null,

  niCentresAffected: false,
  niCentresEntered: null,
  niCentresDirectlyAffected: null,
  niCentresIndirectlyAffected: null,
  niLearnersEntered: null,
  niLearnersDirectlyAffected: null,
  niLearnersIndirectlyAffected: null,

  walesCentresAffected: false,
  walesCentresEntered: null,
  walesCentresDirectlyAffected: null,
  walesCentresIndirectlyAffected: null,
  walesLearnersEntered: null,
  walesLearnersDirectlyAffected: null,
  walesLearnersIndirectlyAffected: null,

  otherCentresAffected: false,
  otherCentresEntered: null,
  otherCentresDirectlyAffected: null,
  otherCentresIndirectlyAffected: null,
  otherLearnersEntered: null,
  otherLearnersDirectlyAffected: null,
  otherLearnersIndirectlyAffected: null,

  assessmentMaterialError: false,
  amePaperType: null,
  eventNotificationAMEModificationType: [],
  eventNotificationAMEWhenIdentified: [],
  eventNotificationAMEWhoIdentified: [],
  eventNotificationAMEAssessmentMethod: [],

  securityBreach: false,
  eventNotificationSecurityBreachMeans: [],
  securityBreachEvidenceOfTwoPeoplePresent: null,
  securityBreachIncorrectPaperOutcome: null,

  declaringNonCompliance: null,
  eventNotificationDeclaredNonComplianceGeneralCondition: [],
  eventNotificationDeclaredNonComplianceGeneralSubCondition: [],
  eventNotificationDeclaredNonComplianceQualCondition: [],
  eventNotificationDeclaredNonComplianceSubjectCondition: [],

  eventNotificationIndicatedNonComplianceGeneralCondition: [],
  eventNotificationIndicatedNonComplianceGeneralSubCondition: [],
  eventNotificationIndicatedNonComplianceQualCondition: [],
  eventNotificationIndicatedNonComplianceSubjectCondition: [],

  eventNotificationOfqualActionTaken: [],
  eventNotificationOfqualMitigationTaken: [],

  actionsTakenToIdentifyCauseAndEffect: null,
  actionsTakenToMitigateAdverseEffect: null,
  actionsTakenToPreventReoccurrencce: null,
  aoReference: null,
  resourceTags:[],

  enOfqualIndicatedNonComplianceGeneralCondition: [],
  enOfqualIndicatedNonComplianceGeneralSubCondition: [],
  enOfqualIndicatedNonComplianceQualCondition: [],
  enOfqualIndicatedNonComplianceSubjectCondition: [],
  enOfqualNonComplianceGeneralCondition: [],
  enOfqualNonComplianceGeneralSubCondition: [],
  enOfqualNonComplianceQualCondition: [],
  enOfqualNonComplianceSubjectCondition: []


};
